import { CaseItem, getCustomerCases } from 'cpfr-common';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-19/common-utilities';
import { getSimpleDataFetchSlice } from '@cp-shared-19/frontend-integration';
import { CpDataApi } from 'cp-xhr';

export type RequestHistoryResponseType = {
    customerNumber: string;
    requestsInCaseHistory: CaseItem[];
};

const { reducer, fetchData } = getSimpleDataFetchSlice<RequestHistoryResponseType, DefaultBusinessMarketApiErrorCode>({
    dataName: 'requestHistory',
    fetchCallback(requestConfig) {
        return CpDataApi.get(getCustomerCases(requestConfig?.params?.customerNumber)).then((response) => response.data);
    },
});
export default reducer;
export const fetchRequestHistory = fetchData;
